export function headerShadow(helpers) {
  const header = document.querySelector('header');
  if (!header) return;

  const handleScroll = () => {
    if (window.scrollY > 10) {
      header.classList.add('shadow-md');
    } else {
      header.classList.remove('shadow-md');
    }
  };

  window.addEventListener('scroll', helpers.throttle(handleScroll, 100), {
    passive: true,
  });
  handleScroll();
}
